<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Contacto</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-container class="fill-height">
            <v-row align="center">
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="telefono != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Central telefónica</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="telefono != ''"
              >
                <span class="ml-5 align-self-center">{{ telefono }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="direccion != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Dirección</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="direccion != ''"
              >
                <span class="ml-5 align-self-center">{{ direccion }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="horario != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Horario de atención</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="horario != ''"
              >
                <span class="ml-5 align-self-center">{{ horario }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="url_webpage != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Página Web</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="url_webpage != ''"
              >
                <span class="ml-5 align-self-center">
                  <a target="_blank" :href="url_webpage">{{ url_webpage }}</a>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="url_youtube != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >YouTube</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="url_youtube != ''"
              >
                <span class="ml-5 align-self-center">
                  <a target="_blank" :href="url_youtube">{{ url_youtube }}</a>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="url_facebook != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Facebook</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="url_facebook != ''"
              >
                <span class="ml-5 align-self-center">
                  <a target="_blank" :href="url_facebook">{{ url_facebook }}</a>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="url_twitter != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Twitter</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="url_twitter != ''"
              >
                <span class="ml-5 align-self-center">
                  <a target="_blank" :href="url_twitter">{{ url_twitter }}</a>
                </span>
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex justify-end"
                v-if="url_instagram != ''"
              >
                <label class="align-self-center mr-5" style="text-align: right;"
                  >Instagram</label
                >:
              </v-col>
              <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                class="pa-1 d-flex"
                v-if="url_instagram != ''"
              >
                <span class="ml-5 align-self-center">
                  <a target="_blank" :href="url_instagram">{{
                    url_instagram
                  }}</a>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Contacto",
  data() {
    return {
      telefono: "",
      direccion: "",
      horario: "",
      url_facebook: "",
      url_youtube: "",
      url_instagram: "",
      url_twitter: "",
      url_webpage: ""
    };
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    async loadDatos() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/config/ListarDatosContacto`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      console.log(respuesta);
      const data = Array.isArray(respuesta.data) ? respuesta.data : [];

      data.forEach(el => {
        switch (el.codigo) {
          case "EMPRESA_TELEFONO":
            this.telefono = el.valor;
            break;
          case "EMPRESA_DIRECCION":
            this.direccion = el.valor;
            break;
          case "EMPRESA_HORARIO":
            this.horario = el.valor;
            break;
          case "EMPRESA_URL_FACEBOOK":
            this.url_facebook = el.valor;
            break;
          case "EMPRESA_URL_YOUTUBE":
            this.url_youtube = el.valor;
            break;
          case "EMPRESA_URL_INSTAGRAM":
            this.url_instagram = el.valor;
            break;
          case "EMPRESA_URL_TWITTER":
            this.url_twitter = el.valor;
            break;
          case "EMPRESA_URL_WEBPAGE":
            this.url_webpage = el.valor;
            break;
        }
      });
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    this.loadDatos();
  }
};
</script>

<style>
</style>